import React, { useEffect, useState } from "react";
import { Modal, Tabs as TabsAntd, TabsProps } from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setButtonsHeader } from "redux/reducer/common";
import { jsonParse } from "helper/common";
import { listTab as allTabs } from "data/list";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { setIsChangetab } from "redux/reducer/residentialNurse";
const Tabs = ({
  items = [],
  defaultActiveKey,
  activeKey,
  onChange,
  onTabClick,
  destroyInactiveTabPane,
  ...props
}: TabsProps) => {
  const dispatch = useAppDispatch();
  // const [defaultKey, setDefaultKey] = useState();
  const defaultKey = defaultActiveKey ? defaultActiveKey : items[0].key;
  const listTab = jsonParse(localStorage.getItem("listTab"));
  // console.log(listTab);
  const isChangeTab = useAppSelector((e) => e.residentialNurse.isChangeTab);
  console.log("🚀 ~ isChangeTab:", isChangeTab);

  const closeModal = () => {
    dispatch(setIsChangetab(true));
  };
  const onOk = (key) => {
    dispatch(setIsChangetab(false));
    localStorage.setItem("currentTab", key);
    dispatch(setActiveKey(key));
  };
  items = items.filter(
    (e) =>
      !allTabs.some((tab) => tab?.tabKey == e?.key) ||
      (allTabs.some((tab) => tab?.tabKey == e?.key) &&
        listTab?.includes(e?.key))
  );
  const showModal = (key) => {
    Modal.confirm({
      title: "Bạn có muốn thoát mà không lưu?",
      icon: <ExclamationCircleFilled />,
      onOk() {
        onOk(key);
      },
      onCancel() {
        closeModal();
      },
      cancelText: "Ở lại",
      okText: "Thoát",
      okType: "danger",
    });
  };
  onChange = (key) => {
    if (isChangeTab) {
      // dispatch(setNextActiveKey(key));
      showModal(key);
      return;
    }

    localStorage.setItem("currentTab", key);
    dispatch(setActiveKey(key));
    dispatch(setButtonsHeader([]));
  };

  useEffect(() => {
    if (
      items.findIndex(
        (item) => item.key == localStorage.getItem("currentTab")
      ) == -1
    ) {
      localStorage.removeItem("currentTab");
    }

    dispatch(setActiveKey(localStorage.getItem("currentTab") || defaultKey));
  }, []);
  return (
    <TabsAntd
      {...props}
      defaultActiveKey={defaultKey}
      items={items as TabsProps["items"]}
      onChange={(key) => {
        onChange(key);
      }}
      activeKey={localStorage.getItem("currentTab") ?? activeKey}
      onTabClick={onTabClick}
      destroyInactiveTabPane={destroyInactiveTabPane}
    />
  );
};
export default Tabs;
